<script type="ts">
	export const hydrate = false;

	export let title: string;
	export let size: 1 | 2 | 3 | 4 | 5 = 5;
	export let group: string;

	const element = `h${size}`;
</script>

<div class="numsec" style="--counter: {group};">
	<svelte:element this={element} class="title">{title}</svelte:element>
	<div class="subtitle"><slot /></div>
</div>

<style lang="scss">
	.numsec {
		color: var(--text-color-alt);
		font-family: var(--font-heading);
		margin-top: 60px;
		counter-increment: var(--counter);
		position: relative;

		display: grid;
	}

	.title {
		position: relative;
		@include min_laptop() {
			&:before {
				content: '#' counter(var(--counter));
				position: absolute;
				font-size: 7rem;
				top: -1rem;
				right: calc(20px + 100%);

				opacity: 0.1;
				line-height: 1;
				user-select: none;
			}
		}
	}

	.title {
		margin: 0;
	}

	.subtitle {
		font-size: 1.25em;
		margin-bottom: 1rem;

		border-top: 2px solid currentColor;
		padding-top: 10px;
		margin-top: 10px;
	}
</style>
